import { buildState, IEntityState } from '@briebug/ngrx-auto-entity';
import { BidItem } from '@app/models';

export const {
  initialState: bidItemInitialState,
  selectors: bidItemSelectors,
  facade: BidItemFacadeBase,
} = buildState(BidItem);

export function bidItemReducer(
  state = bidItemInitialState
): IEntityState<BidItem> {
  return state;
}
